export const texts = [
  {
    id: 'text1',
    text: 'Moderní etický trénink',
  },
  {
    id: 'text2',
    text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.',
  },
  {
    id: 'text3',
    text: 'Lorem ipsum.',
  },
];
